import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {isLoggedIn, isMobileAppUser} from "../Utils";
import {getToken} from "../Utils/Common";


/*
    Public Routes are accessible only without Handwai credentials :) .
 */


function PublicRoutes(props) {
    const {component: Component, ...rest} = props;
    const render = () => {
        if (isLoggedIn() && getToken()) {
            if (isMobileAppUser()) {
                return <Redirect
                    to={process.env.REACT_APP_FRONTEND_PATH_TAETIGKEITSBERICHTPAGE}/>
            } else {
                return <Redirect
                    to={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}/>
            }
        }
        return <Component {...props} />;
    };

    return <Route {...rest} render={render}/>;
}

export default PublicRoutes;
